import { Stack, styled, Typography, type CSSObject } from '@mui/material';
import { theme } from '@rumblefish/ui';

export const StyledStack = styled(Stack)(({ theme }) => ({
  flexFlow: 'column nowrap',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingBottom: theme.spacing(12),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(4, 0),
  },
}));

export const StyledTwoTitles = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(3),
  alignItems: 'flex-start',
  zIndex: '1',
  marginBottom: theme.spacing(6),
  [theme.breakpoints.down('sm')]: {
    gridAutoFlow: 'row',
    marginBottom: theme.spacing(4),
  },
}));

export const StyledFirstTitle = styled(Typography)(({ theme }) => ({
  ...(theme.mixins.neutralGradient as CSSObject),
  display: 'flex',
  justifyContent: 'center',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  [theme.breakpoints.down('sm')]: {
    textAlign: 'center',
    alignSelf: 'center',
  },
}));

export const StyledSecondTitle = styled(Typography)(
  ({ theme: { breakpoints } }) => ({
    ...(theme.mixins.neutralGradient as CSSObject),
    color: 'white',
    letterSpacing: '-0.02em',
    display: 'flex',
    [breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  })
);

export const StyledBenefitsWrapper = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  border: `1px solid ${theme.palette.greyBackgroundColor?.SURFACE + '10'}`,
  borderRadius: theme.spacing(4),
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}));

export const SingleBenefitWrapper = styled(Stack)(({ theme }) => {
  return {
    flex: 1,
    gap: theme.spacing(2),
    borderRight: `1px solid ${
      theme.palette.greyBackgroundColor?.SURFACE + '10'
    }`,
    '&:last-child': {
      borderRight: '0px !important',
    },
    padding: `${theme.utils.fluidSize({
      minSize: 18,
      maxSize: 48,
      minBp: 960,
    })}`,
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(3),
      borderRight: '0px',
    },
    [theme.breakpoints.up('xl')]: {
      padding: theme.spacing(6),
    },
  };
});

export const StyledBenefitHeadline = styled(Typography)(({ theme }) => ({
  color: theme.palette.invertedContent?.PRIMARY,
}));

export const StyledBenefitDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.invertedContent?.SECONDARY,
}));

export const StyledIconWrapper = styled('div')(({ theme }) => ({
  background:
    'radial-gradient(47.45% 48.31% at -0.77% 0%, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0) 100%), rgba(255, 255, 255, 0.03);',
  width: '96px',
  height: '96px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  marginRight: '20px',
  [theme.breakpoints.down('md')]: {
    marginRight: '0',
    marginTop: '10%',
  },
}));

export const StyledIconBackground = styled('div')(({}) => ({
  background: 'rgba(246, 163, 81,0.05)',
  width: '70px',
  height: '70px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
}));

export const StyledIcon = styled('img')(({}) => ({
  background: 'transparent',
  position: 'relative',
  height: '43px',
  aspectRatio: '1/1',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
